<app-entity-mat-dialog-title title="Redeem Gift Certificate"></app-entity-mat-dialog-title>

<div mat-dialog-content>
  <div class="row align-items-center">
    <div class="col-8">
      <mat-form-field class="full-width-field">
        <mat-label>Gift Certificate Code</mat-label>
        <input matInput
               [(ngModel)]="code"
               [ngModelOptions]="{standalone: true}"
               (keydown.enter)="lookup(); $event.preventDefault();"
               autocapitalize="characters"
               placeholder="e.g. 8ZDAE5N2">
      </mat-form-field>
    </div>
    <div class="col-4">
      <button mat-stroked-button color="primary" type="button" [disabled]="lookupPending || !code" (click)="lookup()">
        <mat-icon>search</mat-icon>
        Look Up
      </button>
    </div>
  </div>

  <mat-progress-bar [class.invisible]="!lookupPending" mode="indeterminate"></mat-progress-bar>

  <p class="text-danger" *ngIf="lookupError">{{ lookupError }}</p>

  <ng-container *ngIf="certificate">
    <div class="row mb-2">
      <div class="col-md-6">
        <p class="mb-1"><strong>Code:</strong> {{ certificate.code }}</p>
        <p class="mb-1"><strong>Package:</strong> {{ certificate.package_name || '-' }}<span *ngIf="certificate.lesson_count"> ({{ certificate.lesson_count }} lessons)</span></p>
        <p class="mb-1"><strong>Value:</strong> {{ certificate.amount | studioCurrency }}</p>
      </div>
      <div class="col-md-6">
        <p class="mb-1"><strong>Purchased at:</strong> {{ certificate.purchase_studio_name || '-' }}</p>
        <p class="mb-1"><strong>Recipient:</strong> {{ certificate.recipient_name || '-' }}</p>
        <p class="mb-1"><strong>Expires:</strong> {{ reportDateService.formatDate(certificate.expiration_date) }}</p>
      </div>
    </div>

    <p class="text-danger" *ngIf="!certificate.redeemable_as_package">
      {{ certificate.package_error }}
    </p>

    <ng-container *ngIf="certificate.redeemable_as_package">
      <mat-radio-group [(ngModel)]="mode" [ngModelOptions]="{standalone: true}" class="d-block mb-3">
        <mat-radio-button value="existing" class="me-4">Existing student</mat-radio-button>
        <mat-radio-button value="new">Create a new student account</mat-radio-button>
      </mat-radio-group>

      <div *ngIf="mode === 'existing'">
        <mat-form-field class="full-width-field">
          <mat-label>Student Account</mat-label>
          <input matInput
                 [(ngModel)]="existingStudent"
                 [ngModelOptions]="{standalone: true}"
                 (input)="onAutocompleteStudent($event)"
                 [matAutocomplete]="autoCompleteStudent">
          <mat-autocomplete #autoCompleteStudent="matAutocomplete">
            <mat-option *ngFor="let option of autoCompleteStudentOptions" [value]="option.label + ' (' + option.value + ')'">
              {{ option.label }} ({{ option.value }})
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div *ngIf="mode === 'new'">
        <app-student-account-entity
          [embedded]="true"
          [prefillContact]="prefillContact"
          [prefillInquiryTaker]="certificate?.executive_id"
          (studentCreated)="onStudentCreated($event)"
          (studentCreateFailed)="onStudentCreateFailed()">
        </app-student-account-entity>
      </div>
    </ng-container>
  </ng-container>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" type="button" (click)="_dialogRef.close()">Cancel</button>

  <button *ngIf="certificate?.redeemable_as_package && mode === 'existing'"
          mat-raised-button color="primary" type="button"
          [disabled]="!canRedeemExisting || redeeming"
          (click)="redeemExisting()">
    <mat-icon>redeem</mat-icon>
    Redeem to Student
  </button>

  <button *ngIf="certificate?.redeemable_as_package && mode === 'new'"
          mat-raised-button color="primary" type="button"
          [disabled]="!canRedeemNew || redeeming"
          (click)="createStudentAndRedeem()">
    <mat-icon>person_add</mat-icon>
    Create Student &amp; Redeem
  </button>
</mat-dialog-actions>
